<template>
  <component :is="theme.components.BaseElementLayout" :el$="el$">
    <template slot="field">
      <slot name="prefix"></slot>
      <slot slot="label" name="label" :el$="el$"></slot>
      <div class="text-xs-center sentiment">
        <v-icon
          class="material-icons"
          color="green"
          x-large
          value="Good"
          @click="setSentiment('Good')"
        >
          sentiment_satisfied
        </v-icon>

        <v-icon
          class="material-icons"
          color="orange"
          x-large
          value="Satisfactory"
          @click="setSentiment('Satisfactory')"
        >
          sentiment_neutral
        </v-icon>

        <v-icon
          class="material-icons"
          color="red"
          x-large
          value="Below Average"
          @click="setSentiment('Below Average')"
        >
          sentiment_dissatisfied
        </v-icon>

        <h3>{{ this.model }}</h3>
        <input
          type="hidden"
          class="form-control"
          v-model="model"
          :name="name"
          :id="id"
          ref="text"
          value="sad_sentiment"
        />
      </div>
      <v-textarea
        v-if="this.model == 'Below Average'"
        solo
        :model="why_sentiment"
        name="why_sentiment"
        label="Please enter a reason why..."
      ></v-textarea>
      <slot name="suffix"></slot>
    </template>
    <slot slot="info" name="info" :el$="el$"></slot>
    <slot slot="before" name="before" :el$="el$"></slot>
    <slot slot="between" name="between" :el$="el$"></slot>
    <slot slot="error" name="error" :el$="el$"></slot>
    <slot slot="after" name="after" :el$="el$"></slot>
  </component>
</template>

<script>
import Vue from 'vue'
import BaseElement from '@laraform/laraform/src/mixins/BaseElement'
import BaseValidation from '@laraform/laraform/src/mixins/BaseValidation'
import TextElement from '@laraform/laraform/src/themes/bs4/components/elements/TextElement'

export default {
  name: 'Sentiment',
  mixins: [BaseElement, BaseValidation, TextElement],
  data: () => ({
    why_sentiment: null
  }),
  methods: {
    setSentiment(sentiment) {
      this.model = sentiment
    }
  },
  watch: {}
}
</script>
